import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const Datenschutz = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <h1 className="legal-title">Datenschutzerklärung</h1>
        </div>
        <Card className="legal-card">
          <CardContent className="legal-content">
            <section className="legal-section">
              <h2>Allgemeiner Hinweis und Pflichtinformationen</h2>
              <h3>Benennung der verantwortlichen Stelle</h3>
              <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
              <p>
                pixel56<br />
                Atilla Ciftcioglu<br />
                Hüttenstraße 100<br />
                56170 Bendorf
              </p>
              <p>
                Die verantwortliche Stelle entscheidet allein oder gemeinsam mit anderen über die 
                Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, 
                Kontaktdaten o. Ä.).
              </p>
            </section>

            <section className="legal-section">
              <h2>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h2>
              <p>
                Nur mit Ihrer ausdrücklichen Einwilligung sind einige Vorgänge der Datenverarbeitung 
                möglich. Ein Widerruf Ihrer bereits erteilten Einwilligung ist jederzeit möglich. 
                Für den Widerruf genügt eine formlose Mitteilung per E-Mail. Die Rechtmäßigkeit der 
                bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
              </p>
            </section>

            <section className="legal-section">
              <h2>Recht auf Beschwerde bei der zuständigen Aufsichtsbehörde</h2>
              <p>
                Als Betroffener steht Ihnen im Falle eines datenschutzrechtlichen Verstoßes ein 
                Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde 
                bezüglich datenschutzrechtlicher Fragen ist der Landesdatenschutzbeauftragte des 
                Bundeslandes, in dem sich der Sitz unseres Unternehmens befindet. Der folgende Link 
                stellt eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten bereit: 
                <a href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html" target="_blank" rel="noopener noreferrer">
                  https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html
                </a>.
              </p>
            </section>

            <section className="legal-section">
              <h2>Recht auf Datenübertragbarkeit</h2>
              <p>
                Ihnen steht das Recht zu, Daten, die wir auf Grundlage Ihrer Einwilligung oder in 
                Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an Dritte aushändigen 
                zu lassen. Die Bereitstellung erfolgt in einem maschinenlesbaren Format. Sofern Sie 
                die direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, 
                erfolgt dies nur, soweit es technisch machbar ist.
              </p>
            </section>

            <section className="legal-section">
              <h2>Recht auf Auskunft, Berichtigung, Sperrung, Löschung</h2>
              <p>
                Sie haben jederzeit im Rahmen der geltenden gesetzlichen Bestimmungen das Recht auf 
                unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, Herkunft der 
                Daten, deren Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf 
                Berichtigung, Sperrung oder Löschung dieser Daten. Diesbezüglich und auch zu weiteren 
                Fragen zum Thema personenbezogene Daten können Sie sich jederzeit über die im 
                Impressum aufgeführten Kontaktmöglichkeiten an uns wenden.
              </p>
            </section>

            <section className="legal-section">
              <h2>SSL- bzw. TLS-Verschlüsselung</h2>
              <p>
                Aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, die Sie 
                an uns als Seitenbetreiber senden, nutzt unsere Website eine SSL-bzw. TLS-Verschlüsselung. 
                Damit sind Daten, die Sie über diese Website übermitteln, für Dritte nicht mitlesbar. 
                Sie erkennen eine verschlüsselte Verbindung an der „https://" Adresszeile Ihres Browsers 
                und am Schloss-Symbol in der Browserzeile.
              </p>
            </section>

            <section className="legal-section">
              <h2>Kontaktformular</h2>
              <p>
                Per Kontaktformular übermittelte Daten werden einschließlich Ihrer Kontaktdaten 
                gespeichert, um Ihre Anfrage bearbeiten zu können oder um für Anschlussfragen 
                bereitzustehen. Eine Weitergabe dieser Daten findet ohne Ihre Einwilligung nicht statt.
              </p>
              <p>
                Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt ausschließlich 
                auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Ein Widerruf Ihrer 
                bereits erteilten Einwilligung ist jederzeit möglich. Für den Widerruf genügt eine 
                formlose Mitteilung per E-Mail. Die Rechtmäßigkeit der bis zum Widerruf erfolgten 
                Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.
              </p>
              <p>
                Über das Kontaktformular übermittelte Daten verbleiben bei uns, bis Sie uns zur 
                Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder keine 
                Notwendigkeit der Datenspeicherung mehr besteht. Zwingende gesetzliche Bestimmungen 
                - insbesondere Aufbewahrungsfristen - bleiben unberührt.
              </p>
            </section>

            <section className="legal-section">
              <h2>Google reCAPTCHA</h2>
              <h3>Art und Umfang der Verarbeitung</h3>
              <p>
                Wir haben auf unserer Website Komponenten von Google reCAPTCHA integriert. Google 
                reCAPTCHA ist ein Dienst der Google Ireland Limited und ermöglicht uns zu unterscheiden, 
                ob eine Kontaktanfrage von einer natürlichen Person stammt oder automatisiert mittels 
                eines Programmes geschieht.
              </p>
              <h3>Zweck und Rechtsgrundlage</h3>
              <p>
                Der Einsatz von Google reCAPTCHA erfolgt auf Grundlage Ihrer Einwilligung gemäß 
                Art. 6 Abs. 1 lit. a. DSGVO und § 25 Abs. 1 TTDSG.
              </p>
            </section>

            <section className="legal-section">
              <h2>Google Tag Manager</h2>
              <h3>Art und Umfang der Verarbeitung</h3>
              <p>
                Wir nutzen den Google Tag Manager der Google Ireland Limited, Gordon House, Barrow Street, 
                Dublin 4, Irland. Google Tag Manager wird verwendet, um Website-Tags über eine Oberfläche 
                zu verwalten und ermöglicht es uns, die genaue Integration von Diensten auf unserer 
                Website zu steuern.
              </p>
            </section>

            <section className="legal-section">
              <h2>Facebook Pixel</h2>
              <h3>Art und Umfang der Verarbeitung</h3>
              <p>
                Wir verwenden Facebook Pixel von Meta Platforms Ireland Limited, 4 Grand Canal Square, 
                Grand Canal Harbour, Dublin 2, Ireland, um sogenannte Custom Audiences zu erstellen, 
                also Besuchergruppen unseres Onlineangebotes zu segmentieren, Conversion-Rates zu 
                ermitteln und diese anschließend zu optimieren.
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Datenschutz;
